import { BillingPlanIds } from '../../../../enums/billing-plan-ids';
import { TRIAL_PLAN_CODE } from '../../../../constants/plan-codes';

type TrialPlanInfo = {
  plan?: { code?: string };
  planCode?: string;
  billingPlanId?: string | number;
};

export const isTrialPlan = ({ plan, planCode, billingPlanId }: TrialPlanInfo): boolean =>
  plan?.code?.toLowerCase() === TRIAL_PLAN_CODE ||
  planCode?.toLowerCase() === TRIAL_PLAN_CODE ||
  Number.parseInt(String(billingPlanId), 10) === BillingPlanIds.Trial;
